<template>
    <div>
        <a target="_blank" :href="url" :class="classes">{{description}}</a>
    </div>
</template>

<script>
    /*
    public const Unscheduled = 0;
    public const YetToStart = 10;
    public const Imminent = 15;
    public const InProgress = 20;
    public const Finished = 30;
    public const Unknown = 99;
     */

    export default {
        name: "SessionStatus",
        computed:
            {
                url() {

                  if (this.status === 15) {
                    return this.link;
                  }
                  if (this.status === 20) {
                    return this.link;
                  }
                  return '#';
                },
                description() {

                  if (this.status === -1) {
                    return 'waiting...';
                  }
                  if (!this.status) {
                    return '-';
                  }

                  if (this.status === 0) {
                    return 'Unscheduled';
                  }

                  if (this.status === 15) {
                    return 'Starting Soon (Enter Early)';
                  }

                  if (this.status === 20) {
                    return 'Enter (In Progress)';
                  }
                  if (this.status === 30) {
                    return 'Finished';
                  }
                  if (this.status === 10) {
                    return 'Later';
                  }
                  return 'Unknown';
                },
                tag_class() {

                },
                classes() {
                  if (this.status === 30) {
                    return 'tag is-default';
                  }

                  if (this.status === 15) {
                    return 'tag is-warning';
                  }

                  if (this.status === 10) {
                    return 'tag is-default';
                  }

                    if (this.status) {
                      return 'tag is-success';
                    }
                  return 'tag is-danger';
                }
            },
        props:
            {
                session: {
                    type: Object,
                    required: true
                },
                link: {
                    type: String,
                    required: true,
                }
            },

        data() {
            return {
              foo: 'bar',
              show: true,
              status: -1,
            }
        },

        methods: {
            fetchEventsList() {
                axios.get('/api/session/' + this.session.id + '/status')
                    .then(
                        (response) => (
                            this.status = response.data.status
                        )
                    );
            },
            cancelAutoUpdate() {
                clearInterval(this.timer)
            }

        },

        beforeCreate() {

        },
        created() {
            this.fetchEventsList();
            this.timer = setInterval(this.fetchEventsList, 55000);
        },
        beforeMount() {

        },
        mounted() {

        },
        beforeUpdate() {

        },
        updated() {

        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        destroyed() {

        }


    };
</script>

<style scoped>

</style>